module.exports = __webpack_public_path__ + "img/KSC04498.8d7d1ff1.jpg";